module.exports = __webpack_public_path__ + "img/invite.fef022ba.svg";